<template>
  <v-card class="mt-2">
    <v-card-title style="padding:8px;padding-top=16px">商品明細</v-card-title>
    <v-card-actions v-if="canEdit">
      <v-btn @click="itemDialog.show=true">{{$t('app.buttons.add')}}</v-btn>
      <v-btn @click="remove">{{$t('app.buttons.remove')}}</v-btn>
      <table-upload @input="upload" title="商品明細Upload" />
      <a
        @click="$downloadTemplate('B0200','cargoList')"
        href="#"
        style="margin-left: 10px"
      >UL用ファイルDL</a>
    </v-card-actions>
    <v-data-table
      :headers="headers"
      :hide-actions="true"
      :items="quotation.items"
      :rows-per-page-items="[10]"
      class="elevation-1 inline-edit"
      item-key="seq"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{props.index+1}}</td>
        <td>
          <query-autocomplete
            :init-items="[{code: props.item.skuCode}]"
            :rules="[v => !!v || '商品 is required']"
            clearable
            item-text="code"
            item-value="code"
            style="width:220px"
            url="skus?code={term}"
            v-model="props.item.skuCode"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || '単価 is required']"
            @change="calcSubTotal(props.item)"
            clearable
            type="number"
            v-model.number="props.item.unitPrice"
          />
        </td>
        <td>
          <remote-autocomplete
            :rules="[v => !!v || '通貨 is required']"
            @change="v=>chooseCurrency(props.item,v)"
            item-text="iso3code"
            item-value="code"
            returnObject
            style="width:100px"
            url="currencies/all"
            v-model="props.item.currencyCode"
          />
        </td>
        <td>
          <v-text-field
            :value="props.item.currencyRate"
            @input="v=>handwriteCurrencyRate(props.item,v)"
          />
        </td>
        <td>{{props.item.unitPrice*props.item.currencyRate | currency({fractionCount:0})}}</td>
        <td>
          <v-text-field
            :rules="[v => !!v || '輸入数 is required']"
            @change="calcSubTotal(props.item)"
            clearable
            type="number"
            v-model.number="props.item.qty"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || '入り数 is required']"
            clearable
            type="number"
            v-model.number="props.item.perCartonQty"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || 'G/W is required']"
            @change="props.item.perCartonGrossWeight=$numberScale2(props.item.perCartonGrossWeight)"
            clearable
            type="number"
            v-model="props.item.perCartonGrossWeight"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || '縦寸法 is required']"
            clearable
            type="number"
            v-model.number="props.item.cartonWidth"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || '横寸法 is required']"
            clearable
            type="number"
            v-model.number="props.item.cartonLength"
          />
        </td>
        <td>
          <v-text-field
            :rules="[v => !!v || '高さ is required']"
            clearable
            type="number"
            v-model.number="props.item.cartonHeight"
          />
        </td>
        <td>{{getAcw(props.item)}}</td>
      </template>
    </v-data-table>
    <search-order-dialog ref="pickOrderDlg" />
    <item-dialog :dialog="itemDialog" @submit="itemSubmit($event)" />
  </v-card>
</template>
<script>
import SearchOrderDialog from './SearchOrderDialog'
import ItemDialog from './ItemDialog'

export default {
  components: { SearchOrderDialog, ItemDialog },
  props: ['quotation', 'canEdit'],
  data() {
    return {
      selected: [],
      itemDialog: {
        show: false,
      },
      headers: [
        { text: 'NO', value: 'no', sortable: false },
        { text: '商品', value: 'skuCode', sortable: false, width: '220px' },
        { text: 'FOB単価', value: 'unitPrice', sortable: false },
        {
          text: '通貨',
          value: 'currencyCode',
          sortable: false,
          width: '100px',
        },
        {
          text: 'レート',
          value: 'currencyRate',
          sortable: false,
        },
        { text: 'JPY単価', value: 'jpyPrice', sortable: false },
        { text: '輸入数', value: 'qty', sortable: false },
        {
          text: '入り数',
          value: 'perCartonQty',
          sortable: false,
        },
        {
          text: 'G/W(kg)',
          value: 'perCartonGrossWeight',
          sortable: false,
        },
        {
          text: '箱縦寸法(cm)',
          value: 'cartonWidth',
          sortable: false,
        },
        {
          text: '箱横寸法(cm)',
          value: 'cartonLength',
          sortable: false,
        },
        {
          text: '箱高さ(cm)',
          value: 'cartonHeight',
          sortable: false,
        },
        {
          text: 'acw',
          value: 'acw',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    handwriteCurrencyRate(item, v) {
      item.currencyRate = v
      item.isCurrencyRateHandwrite = true
    },
    chooseCurrency(item, v) {
      if (v) {
        item.currencyCode = v.code
        item.isCurrencyRateHandwrite = false
        item.currencyRate = this.$getCurrencyRate(
          v,
          'INTERNAL',
          new Date().format('yyyy-MM-dd')
        )
      }
    },

    isValid(value) {
      return value !== null && value !== undefined
    },
    getCantonQty(item) {
      return Math.ceil(item.qty / item.perCartonQty)
    },
    getTotalGrossWeight(item) {
      return this.getCantonQty(item) * item.perCartonGrossWeight
    },
    getVolume(item) {
      return item.cartonWidth * item.cartonLength * item.cartonHeight
    },
    getTotalVolumeCW6000(item) {
      function round2(value) {
        return Math.round(value * 100.0) / 100
      }
      return round2((this.getCantonQty(item) * this.getVolume(item)) / 6000.0)
    },
    getAcw(item) {
      return Math.max(
        this.getTotalGrossWeight(item),
        this.getTotalVolumeCW6000(item)
      )
    },
    calcSubTotal(item) {
      item.subTotal = (item.qty || 0) * (item.unitPrice || 0)
    },
    itemSubmit(item) {
      this.itemDialog.show = false
      this.quotation.items.push({ ...item, seq: new Date().getTime() })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.quotation.items = this.quotation.items.filter(
            (i) => !this.selected.includes(i)
          )
          this.$message('', '削除成功')
          this.selected = []
        }
      )
    },
    upload(data) {
      console.log(data)
      let skus = data
        .filter((d, idx) => idx !== 0)
        .map((d) => ({
          skuCode: d[0],
          unitPrice: d[1],
          currencyCode: d[2],
          currencyRate: null,
          qty: d[3],
          perCartonQty: d[4],
          perCartonGrossWeight: d[5],
          cartonWidth: d[6],
          cartonLength: d[7],
          cartonHeight: d[8],
        }))
      skus.forEach((sku, idx) => {
        this.$http.post(`skus/createIfNotExists`, {
          code: sku.skuCode,
          unitPrice: sku.unitPrice,
          unitPriceCurrencyCode: sku.currencyCode,
          boxQty: sku.perCartonQty,
          boxWeight: sku.perCartonGrossWeight,
          boxWidth: sku.cartonWidth,
          boxLength: sku.cartonLength,
          boxHeight: sku.cartonHeight,
        })
        this.quotation.items.push({ ...sku, seq: new Date().getTime() + idx })
      })
    },
  },
}
</script>

